var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.1,
    height: 36,
    viewBox: "0 0 38.1 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "wallet",
    d: "M32.6,27.2a3.064,3.064,0,0,0,2.225-.975A3.118,3.118,0,0,0,35.8,23.95a2.983,2.983,0,0,0-.975-2.2,3.081,3.081,0,0,0-4.45,0,2.983,2.983,0,0,0-.975,2.2,3.118,3.118,0,0,0,.975,2.275A3.064,3.064,0,0,0,32.6,27.2ZM9,36.35v0ZM9,42a2.906,2.906,0,0,1-2.075-.9A2.841,2.841,0,0,1,6,39V9a2.869,2.869,0,0,1,.925-2.075A2.869,2.869,0,0,1,9,6H39a2.841,2.841,0,0,1,2.1.925A2.906,2.906,0,0,1,42,9v6.7H39V9H9V39H39V32.35h3V39a3.076,3.076,0,0,1-3,3Zm17.9-8.65a3.648,3.648,0,0,1-2.7-1,3.582,3.582,0,0,1-1-2.65V18.35a3.564,3.564,0,0,1,1-2.675,3.7,3.7,0,0,1,2.7-.975H40.4a3.7,3.7,0,0,1,2.7.975,3.564,3.564,0,0,1,1,2.675V29.7a3.582,3.582,0,0,1-1,2.65,3.648,3.648,0,0,1-2.7,1Zm14.2-3V17.7H26.2V30.35Z",
    transform: "translate(-6 -6)",
    fill: "#f7f6f6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.1986ab3093665788def793c8e19de6a1.svg";
export { ForwardRef as ReactComponent };